import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAllEvents } from 'api/events';
import { App, Button, Card, Spin } from 'antd';
import NewEventDialog from './NewEventDialog';
import Page from 'components/Page';
import { Link } from 'react-router-dom';
import { CalendarOutlined } from '@ant-design/icons';
import { useI18n } from 'components/I18nProvider';
import styles from './style.module.scss';
import { buildUrlPath } from 'lib/resolveUrl';
const EventsPage = () => {
    const { intl } = useI18n();
    const { message } = App.useApp();
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newEventDialogOpened, setNewEventDialogOpened] = useState(false);
    useEffect(() => {
        const fetchEvents = async () => {
            setLoading(true);
            try {
                const events = await fetchAllEvents();
                setEvents(events);
            }
            catch (error) {
                console.error('Failed to fetch events:', error);
                void message.error(intl.formatMessage({ id: 'eventsLoadFailed' }));
            }
            finally {
                setLoading(false);
            }
        };
        void fetchEvents();
    }, [intl, message]);
    const handleOpenNewEventDialog = () => {
        setNewEventDialogOpened(true);
    };
    const handleNewEvent = (event) => {
        navigate(buildUrlPath(`/admin/events/${event.id}`));
    };
    const handleCloseNewEventDialog = () => {
        setNewEventDialogOpened(false);
    };
    return (_jsxs(Page, { children: [_jsx("div", { className: styles.toolbar, children: _jsx(Button, { type: "primary", onClick: handleOpenNewEventDialog, "test-id": "admin-events-new-event-button", children: intl.formatMessage({ id: 'newEvent' }) }) }), _jsx(Card, { title: intl.formatMessage({ id: 'events' }), children: _jsx(Spin, { spinning: loading, children: events.map((event) => (_jsxs("div", { className: styles.eventItem, children: [_jsx(CalendarOutlined, {}), _jsx(Link, { to: buildUrlPath(`/admin/events/${event.id}`), "test-id": `admin-events-event-link-${event.id}`, children: event.title })] }, event.id))) }) }), _jsx(NewEventDialog, { open: newEventDialogOpened, onNewEvent: handleNewEvent, onClose: handleCloseNewEventDialog })] }));
};
export default EventsPage;
